(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productV1JSON").textContent);

    // map selling plan id -> name; a variant's allocations only carry selling_plan_id, names live on the groups
    const sellingPlanIDtoName = {};
    product.selling_plan_groups.forEach(group => {
        group.selling_plans.forEach(plan => {
            // strip the discount suffix, e.g. "every 45 days (save 25%)" -> "every 45 days"
            sellingPlanIDtoName[plan.id] = plan.name.replace(/\s*\(\s*save[^)]*\)/gi, "").trim();
        });
    });

    // map variant id -> unit quantity
    const variantQuantities = JSON.parse(section.querySelector(".productV1VariantIDToQuantityJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productV1VariantJSON").textContent);
    let quantity = 1;

    const atcButton = section.querySelector(".productV1ATC");

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/
    const thumbsSwiper = new Swiper(section.querySelector(".productV1VisualThumbs"), {
        spaceBetween: 12,
        slidesPerView: 4,
        mousewheel: true,
        navigation: {
            prevEl: section.querySelector(".productV1VisualThumbsPrev"),
            nextEl: section.querySelector(".productV1VisualThumbsNext")
        },
        breakpoints: {
            1001: {
                direction: "vertical",
                slidesPerView: "auto"
            }
        }
    });

    const productSwiper = new Swiper(section.querySelector(".productV1VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        thumbs: {
            swiper: thumbsSwiper
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productV1VisualSwiperSlide")) {
                    return;
                }
                // pause all videos
                section.querySelectorAll(".productV1VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productV1VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV1VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV1VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });


    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    // clicking anywhere in a selling option selects that option's header radio
    const selling = section.querySelector(".productV1Selling");
    if (selling) {
        selling.addEventListener("click", function (e) {
            const option = e.target.closest(".productV1SellingOption");
            if (!option) {
                return;
            }

            // bail if this option is already selected so we don't re-render needlessly
            const headerInput = option.querySelector(".productV1SellingOptionHeaderInput");
            if (headerInput.checked) {
                return;
            }

            // check the header radio (no native change fires when set programmatically) and refresh
            headerInput.checked = true;
            updateProduct();
        });
    }

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productV1SellingOptionHeaderInput[value="sub"]:checked`);
    }

    // convert a selling plan name like "45 days" or "3 months" to an interval in days, or null when it can't be parsed
    function planIntervalDays(name) {
        if (!name) {
            return null;
        }

        // pull the leading count + unit out of the name (e.g. "Deliver every 3 months")
        const match = name.match(/(\d+)\s*(day|week|month|year)/i);
        if (!match) {
            return null;
        }

        // normalise the unit to days so plans across different units can be compared
        const unitDays = {day: 1, week: 7, month: 30, year: 365};
        return parseInt(match[1]) * unitDays[match[2].toLowerCase()];
    }

    // always subscribe at the highest frequency (shortest interval) available for the active variant
    function currentSellingPlan() {
        const allocations = activeVariant.selling_plan_allocations || [];
        if (!allocations.length) {
            return null;
        }

        // pick the allocation with the shortest parsed interval, falling back to the first plan when none parse
        let bestPlanID = allocations[0].selling_plan_id;
        let bestInterval = null;
        allocations.forEach(allocation => {
            const interval = planIntervalDays(sellingPlanIDtoName[allocation.selling_plan_id]);
            if (interval === null) {
                return;
            }
            if (bestInterval === null || interval < bestInterval) {
                bestInterval = interval;
                bestPlanID = allocation.selling_plan_id;
            }
        });

        return bestPlanID;
    }

    // the allocation for the plan the customer selected (falls back to the first)
    function currentAllocation() {
        const allocations = activeVariant.selling_plan_allocations;
        return allocations.find(item => item.selling_plan_id === currentSellingPlan()) || allocations[0];
    }

    // update each variant option's SAVE badge
    function updateVariantSaves() {
        const subscription = isSubscription();
        const planID = subscription ? currentSellingPlan() : null;


        section.querySelectorAll(".productV1OptionsItemValuesLabelInput").forEach(input => {
            const variant = product.variants.find(item => item.id === parseInt(input.dataset.variantId));
            const save = input.closest(".productV1OptionsItemValuesLabel").querySelector(".productV1OptionsItemValuesLabelSelectorSave");
            if (!variant || !save) {
                return;
            }

            // base off the compare-at price when it beats the regular price, so we always show the largest possible savings
            let base = variant.price;
            if (variant.compare_at_price > variant.price) {
                base = variant.compare_at_price;
            }

            // discount against the selected plan's allocation when subscribing, otherwise the regular price
            let discounted = variant.price;
            if (subscription) {
                const allocation = variant.selling_plan_allocations.find(item => item.selling_plan_id === planID) || variant.selling_plan_allocations[0];
                discounted = allocation ? allocation.price : variant.price;
            }

            // show the rounded percent saved, or clear the badge (hidden via :empty) when there's no discount
            save.textContent = "";
            if (base > discounted) {
                save.textContent = `SAVE ${Math.round((base - discounted) / base * 100)}%`;
            }
        });
    }

    // update the subscription SAVE badges (header + bullets) with the active variant's plan discount
    function updateSubscriptionSave() {
        const allocations = activeVariant.selling_plan_allocations;
        if (!allocations || !allocations.length) {
            return;
        }

        // discount of the selected plan's allocation against the highest base price, so we show the largest possible savings
        const allocationPrice = currentAllocation().price;

        // base off the compare-at price when it beats the regular price
        let base = activeVariant.price;
        if (activeVariant.compare_at_price > activeVariant.price) {
            base = activeVariant.compare_at_price;
        }

        let percent = 0;
        if (base > allocationPrice) {
            percent = Math.round((base - allocationPrice) / base * 100);
        }

        // inline bullet [save] tokens just show the percent
        section.querySelectorAll(".productV1SellingOptionBulletsItemSave").forEach(save => {
            save.textContent = "";
            if (percent) {
                save.textContent = `${percent}%`;
            }
        });
    }

    // show the active variant's plan name in the always-on bullet (e.g. "Delivered every 45 days")
    function updatePlanBullet() {
        const planBullet = section.querySelector(".productV1SellingOptionBulletsItemPlan");
        if (!planBullet) {
            return;
        }

        // clear when this variant has no plan, otherwise show its plan name
        planBullet.textContent = "";
        const planID = currentSellingPlan();
        if (planID) {
            // sentence case the plan name so only the first letter is capitalized
            const planName = sellingPlanIDtoName[planID];
            planBullet.textContent = `${planName.charAt(0).toUpperCase()}${planName.slice(1).toLowerCase()}`;
        }
    }

    /**************
     Selling Plans
     ***************/

    async function updateProduct() {
        // find active variant
        activeVariant = await getActiveVariant();

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            atcButton.disabled = true;
            section.querySelector(".productV1ATCText").textContent = "Not Available";
            return;
        }

        // update dynamic elements
        updateVariantSaves();
        updateSubscriptionSave();
        updatePlanBullet();

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

            // divide the prices by the variant's unit quantity to show a per-unit price
        const perUnit = variantQuantities[activeVariant.id] || 1;

        // subscription compares against the highest base price, so we show the largest possible savings
        let subBase = activeVariant.price;
        if (activeVariant.compare_at_price > activeVariant.price) {
            subBase = activeVariant.compare_at_price;
        }

        // the selling options only render when the first variant has selling plans, index 0 is subscribe and 1 is one-time
        const compares = section.querySelectorAll(".productV1SellingOptionHeaderPriceCompare");
        const reals = section.querySelectorAll(".productV1SellingOptionHeaderPriceReal");
        if (compares.length > 0) {
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            // subscription price, skipped when this variant has no plans
            if (activeVariant.selling_plan_allocations.length > 0) {
                const allocationPrice = currentAllocation().price;

                // clear the compare first, then only show it when the base beats the price being shown
                subCompare.textContent = "";
                if (subBase > allocationPrice) {
                    subCompare.textContent = price(subBase / perUnit);
                }
                subReal.textContent = price(allocationPrice / perUnit);
            }

            // clear the compare first, then only show it when there's a higher compare-at price
            oneTimeCompare.textContent = "";
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price / perUnit);
            }
            oneTimeReal.textContent = price(activeVariant.price / perUnit);
        }


        // update price
        // show the selected price, with the compare-at struck through when there's a discount
        const atcPrice = isSubscription() ? currentAllocation().price : activeVariant.price;
        const atcCompare = isSubscription() ? subBase : activeVariant.compare_at_price;

        let atcCompareHTML = "";
        if (atcCompare > atcPrice) {
            atcCompareHTML = `<s class="productV1ATCPriceCompare">${price(atcCompare * quantity)}</s>`;
        }

        section.querySelector(".productV1ATCPrice").innerHTML = `${atcCompareHTML} ${price(atcPrice * quantity)}`;

        //update the percent off badge
        const percentOffValue = section.querySelector(".productV1SubheaderPercentOffSaleValue") || false;
        //only change if the value field is present
        if (percentOffValue) {
            if (isSubscription()) {
                percentOffValue.innerText = `${100 - Math.round((atcPrice / product.compare_at_price) * 100)}`
            } else {
                percentOffValue.innerText = `${100 - Math.round((product.price / product.compare_at_price) * 100)}`;
            }
        }


        /**************
         ATC Enable/Disable
         ***************/

        // in stock adds to cart, sold out stays clickable and opens klaviyo's back in stock form
        atcButton.disabled = false;
        atcButton.classList.toggle("soldOut", !activeVariant.available);
        atcButton.classList.toggle("klaviyo-bis-trigger", !activeVariant.available);
        if (activeVariant.available) {
            section.querySelector(".productV1ATCText").textContent = atcButton.dataset.addToCartText;
        } else {
            section.querySelector(".productV1ATCText").textContent = atcButton.dataset.soldOutText;
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    // update product on input change
    section.querySelectorAll(".productV1OptionsItemValuesLabelInput").forEach(function (element) {
        element.addEventListener("change", async function () {
            await updateProduct();
        });
    });

    /**
     * Fetches the active variant based on the selected options.
     * If there are more than 250 variants, it makes a request to the server to fetch the active variant since Shopify's storefront API has a limit of 250 variants per product.
     * @returns {Promise<Object>} The active variant object
     */
    async function getActiveVariant() {
        // Fetch variant when exceeding Shopify's 250 variant limit
        if (product.variants.length >= 250) {
            const optionIDs = [];
            section.querySelectorAll(".productV1OptionsItemValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.id);
            });
            const response = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());
            return response.active_variant;
        }

        // If there's only one variant, return it immediately
        if (product.variants.length === 1) {
            return product.variants[0];
        }

        // Gather selected values
        const options = [];
        section.querySelectorAll('.productV1OptionsItem').forEach(group => {
            options.push(group.querySelector('input:checked').value);
        });

        // Find matching variant and return it
        return product.variants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        );
    }


    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productV1QuantityControlsBtn.minus")?.addEventListener("click", async function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productV1QuantityControlsValue").textContent = quantity;
        await updateProduct();
    });

    // plus
    section.querySelector(".productV1QuantityControlsBtn.plus")?.addEventListener("click", async function () {
        quantity++;
        section.querySelector(".productV1QuantityControlsValue").textContent = quantity;
        await updateProduct();
    });


    /**************
     Product ATC
     ***************/

    async function addToCart() {
        // sold out clicks belong to klaviyo
        if (!activeVariant.available) {
            return;
        }

        // add loading animation to both buttons
        section.querySelector(".productV1ATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan()
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV1ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV1ATC').addEventListener("click", addToCart);
}());